import React from "react";
import { currencyFormat } from "../helpers";

const CurrencyCell = (params) => {
  return <>{currencyFormat(params.value)}</>;
};

export default CurrencyCell; 
